import axios from '../../helpers/axios-setup';

export const uncertifyApplication = ({ id, comment, reason }: { id: number; comment: string; reason: string }) =>
  axios.put(`/admin/applications/unapprove/${id}`, { comment: comment, reason: reason });

export const canUncertifyApplication = (id: number) => axios.get(`/admin/applications/unapprove/${id}`);
